import React, { Component } from "react";
import "font-awesome/css/font-awesome.min.css";
import setIcon from "../images/settings.svg";
import whatweOffer from "../images/what-we-offer.png";
import integraProcess from "../images/integration-process.png";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import "./whyChoose.css";

class WhyChoose extends Component {
  render() {
    return (
      <div className="main-container">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="inner-content">
                <h1>Why Choose Us?</h1>
                <p>
                  At Tata CLiQ, everything you see is hand-picked and 100%
                  authentic – sourced straight from the best brands and their
                  authorized resellers from India and across the world, just for
                  you.
                </p>

                <p>
                  We bring you the <strong>newest –</strong> it’s in-season and
                  on-trend; if it’s on the racks, it’s online. And it’s{" "}
                  <strong>nowest</strong> – have it delivered QUiQly, from a
                  store near you, when you use our Phygital services. It’s New
                  and Now A little over a year from launch, Tata CLiQ is already
                  in the Top 10, and one of the fastest growing, e-commerce
                  companies in the country. Offering flexibility in the way you
                  shop, Tata CLiQ is a first-of-its-kind Phygital marketplace
                  that serves over one million customers. The journey begins
                  online. Engage with us in a seamless shopping experience
                  across desktop, tablet and smartphone. Browse the best Indian
                  and international brands across clothes and accessories
                  (watches, bags, shoes, jewellery and more), gadgets and home
                  appliances. Then go offline with us. Tapping into our strong
                  brand partner network, we have created a Phygital experience
                  that combines the ease of shopping online with the reassurance
                  of buying from a brick-and-mortar store. Use our QUiQ PiQ,
                  QUiQ Exchange and QUiQ Finder services to shop from across
                  2,000 stores and 100 partner brands to pick up or return what
                  you’ve bought,in-store.At Tata CLiQ, everything you see is
                  hand-picked and 100% authentic – sourced straight from the
                  best brands and their authorized resellers from India and
                  across the world, just for you.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WhyChoose;
